import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Pin16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 15.6319C8.43922 15.1348 8.87652 14.6385 9.28988 14.1193C11.0536 11.904 13.25 8.9846 13.25 6.02174C13.25 3.11365 10.9029 0.75 8 0.75C5.0971 0.75 2.75 3.11365 2.75 6.02174C2.75 8.9846 4.94636 11.904 6.71012 14.1193C7.12372 14.6388 7.56047 15.1345 8 15.6319ZM4.25 6.02174C4.25 3.93525 5.93234 2.25 8 2.25C10.0677 2.25 11.75 3.93525 11.75 6.02174C11.75 8.66205 9.57146 11.3813 8 13.3303C6.42854 11.3813 4.25 8.66205 4.25 6.02174Z'
      fill='currentColor'
    />
  </Svg>
);

Pin16.displayName = 'Pin16';
export default Pin16;
